import React, { useEffect, useState } from "react";
import { freight } from "../../lib/freightApi.js";
import { useCarrier } from "./CarrierApp.jsx";
import { Shell, Title, Tile, Quiet, plural, errText } from "./ui.jsx";

/**
 * Home: what needs you today (the schematic's Home board). Two tiles, a number on each, and nothing
 * else: the number is the whole message.
 *
 * ⛔ NOT "Nothing else needs you." The card ends with it, and it is not true yet: turned-down loads,
 * breakdowns and late trucks need the call itself read, which is not built (backend desk.mjs).
 *
 * Hiring counts applicants Alfred has talked to who are waiting on a recruiter. Dispatch counts the
 * desk's Needs you (backend desk.mjs): refused calls, drivers not answering, loads with no driver.
 */

/**
 * "1 load needs a dispatcher" when every item is about a load and no load has two; anything else
 * counts as things. `loads` is the number of DISTINCT loads, `loadItems` the items that name one.
 */
export function dispatchLine(n, loads, loadItems = loads) {
  return loadItems === n && loads === n ? `${plural(n, "load needs", "loads need")} a dispatcher` : `${plural(n, "thing needs", "things need")} a dispatcher`;
}

/** "(1 is a demonstration)": an AI persona's applicant or call is never counted as a person's. */
const demoNote = (n) => (n ? ` (${n} ${plural(n, "is a demonstration", "are demonstrations")})` : "");

export function HomeView({ company, stage, counts, error, areas }) {
  const a = areas || { hiring: true, dispatch: true };
  const tiles = [];
  if (a.hiring) {
    tiles.push(<Tile key="hiring" to="/carrier/hiring" title="Hiring" value={counts?.hiring ? counts.hiring.ready : "–"}
      sub={counts?.hiring ? `${plural(counts.hiring.ready, "applicant is", "applicants are")} ready for a recruiter${demoNote(counts.hiring.readyDemo)}` : "Applicants ready for a recruiter"} />);
  }
  if (a.dispatch) {
    tiles.push(<Tile key="dispatch" to="/carrier/dispatch" title="Dispatch" value={counts?.dispatch ? counts.dispatch.needsYou : "–"}
      sub={counts?.dispatch ? `${dispatchLine(counts.dispatch.needsYou, counts.dispatch.loads, counts.dispatch.loadItems)}${demoNote(counts.dispatch.demo)}` : "Loads and drivers that need a dispatcher"} />);
  }
  return (
    <Shell company={company} stage={stage} gap={32}>
      <Title>What needs you today</Title>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 24 }}>{tiles}</div>
      {error ? <Quiet>{`The numbers could not be read: ${error}`}</Quiet> : null}
    </Shell>
  );
}

export default function Home() {
  const { carrier, me } = useCarrier();
  const [counts, setCounts] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    freight.today().then((c) => alive && setCounts(c)).catch((e) => alive && setError(errText(e)));
    return () => { alive = false; };
  }, []);
  return <HomeView company={carrier.name} stage={carrier.stage} counts={counts} error={error} areas={me.areas} />;
}
